<template>
  <div>
    <Component71 />
    <Component72 />
    <Component74 />
    <Component75 />
    <Component76 />
    <Component98 />
    <Component99 />
  </div>
</template>
<script>
import Component71 from '@/v2/auto/sections/71-map.vue'
import Component72 from '@/v2/auto/sections/72-qmusic.vue'
import Component74 from '@/v2/auto/sections/74-appli.vue'
import Component75 from '@/v2/auto/sections/75-appli.vue'
import Component76 from '@/v2/auto/sections/76-link.vue'
import Component98 from '@/v2/auto/sections/98-footer.vue'
import Component99 from '@/v2/auto/sections/99-footer.vue'
export default {
  components: {
    Component71,
    Component72,
    Component74,
    Component75,
    Component76,
    Component98,
    Component99,
  },
}
</script>
